var map = {
	"./access-code/access-code.module.ngfactory": [
		"./src/app/access-code/access-code.module.ngfactory.js",
		0,
		1,
		2,
		4,
		5,
		6,
		7,
		8,
		18,
		"common",
		20
	],
	"./admin/admin.module.ngfactory": [
		"./src/app/admin/admin.module.ngfactory.js",
		0,
		1,
		10,
		11,
		"common",
		22
	],
	"./dashboard/dashboard.module.ngfactory": [
		"./src/app/dashboard/dashboard.module.ngfactory.js",
		0,
		1,
		2,
		3,
		4,
		5,
		6,
		7,
		8,
		9,
		10,
		13,
		15,
		"common",
		19
	],
	"./export/export.module.ngfactory": [
		"./src/app/export/export.module.ngfactory.js",
		0,
		1,
		2,
		3,
		4,
		6,
		11,
		12,
		"common",
		26
	],
	"./information/information.module.ngfactory": [
		"./src/app/information/information.module.ngfactory.js",
		0,
		3,
		5,
		14,
		"common",
		24
	],
	"./login/login.module.ngfactory": [
		"./src/app/login/login.module.ngfactory.js",
		1,
		10,
		"common",
		28
	],
	"./patient/patient.module.ngfactory": [
		"./src/app/patient/patient.module.ngfactory.js",
		0,
		1,
		2,
		3,
		4,
		5,
		6,
		7,
		8,
		9,
		10,
		12,
		13,
		14,
		15,
		16,
		17,
		18,
		"common",
		21
	],
	"./push-notifications/push-notifications.module.ngfactory": [
		"./src/app/push-notifications/push-notifications.module.ngfactory.js",
		0,
		1,
		2,
		3,
		4,
		5,
		6,
		7,
		8,
		9,
		13,
		16,
		"common",
		27
	],
	"./settings/settings.module.ngfactory": [
		"./src/app/settings/settings.module.ngfactory.js",
		0,
		2,
		7,
		"common",
		23
	],
	"./stats/stats.module.ngfactory": [
		"./src/app/stats/stats.module.ngfactory.js",
		0,
		1,
		2,
		3,
		4,
		5,
		9,
		11,
		12,
		14,
		17,
		"common",
		25
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;